import { connect } from 'react-redux';
import Component from '../../components/js/modules/UserBehaviorLoggerPageView';
import { IStates } from '../CommonStateType';

const mapStateToProps = (state: IStates) => {
  return {
    pageData: state.pageData
  };
};

export default connect(mapStateToProps)(Component);
